import React from 'react';
import { useSimulator } from 'hooks';
import App from '../App';
import Simulator from '../../Simulator';

/**
 * A HOC that gets configuration from location. The App component is memoized so
 * it doesn't update every time the location updates.
 */
function AppWithSimulator() {
  const simulator = useSimulator();
  return (
    <>
      {simulator && <Simulator />}
      <App />
    </>
  );
}

export default AppWithSimulator;
